var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaflet-page"},[_c('img',{attrs:{"src":"//download-cos.yofish.com/ad-gongjushiyebu/20220607153821569-bg.jpg","alt":""}}),_c('div',{staticClass:"submit-btn",on:{"click":_vm.applyAction}},[_vm._v("立即申请")])])}
var staticRenderFns = []

export { render, staticRenderFns }